import React from "react";
import { shopby1, shopby2, shopby3 } from "../Constant/Index";
import { Link } from "react-router-dom";

function Shopbycategory() {
  return (
    <>
      {/* Shop category  */}
      <section className="shopby-category">
        <div className="container">
          <div className="best-seller-heading">
            <h2 className="primary-color">shop by category</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="shopby-category-img">
                <img
                  src={shopby1}
                  alt="shop-by-category"
                  className="img-fluid"
                />
                <div className="shop-by-category-stuff">
                  <h3 className="primary-color">love in fragrance</h3>
                  <p>We believe in natural beauty</p>
                  <div className="shop-category-btn">
                    <Link to="/shop">
                      {" "}
                      <button className="btn-all" style={{ width: "30%" }}>
                        Shop Now
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="second-shop-category">
                <img src={shopby2} alt="shop-category" className="img-fluid" />
                <div className="shop-by-category-stuff">
                  <h3 className="primary-color">natural In beauty</h3>
                  <p>We believe in natural beauty</p>
                  <div className="shop-category-btn">
                  <Link to="/shop">
                      {" "}
                      <button className="btn-all" style={{ width: "30%" }}>
                        Shop Now
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="second-shop-category mt-3">
                <img src={shopby3} alt="shop-category" className="img-fluid" />
                <div className="shop-by-category-stuff">
                  <h3 className="primary-color">best care</h3>
                  <p>We believe in natural beauty</p>
                  <div className="shop-category-btn">
                  <Link to="/shop">
                      {" "}
                      <button className="btn-all" style={{ width: "50%" }}>
                        Shop Now
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* =============== */}
    </>
  );
}

export default Shopbycategory;
